import React from 'react';

import {logoText} from '../config';

const Logo = props => (
    <b>{logoText}</b>
);

export default Logo;